import React from "react";
import "./home.css";
import LuxuryFurnitureSection from "./funiture";
import FurnitureCategories from "./FurnitureCategories";
import WhoWeAre from "./whoweare";
import ProcessSection from "./ProcessSection";
import MachineryTechnology from "./MachineryTechnology";
import BrandLogos from "./BrandLogos";
import Footer from "./Footer";
import Sustainability from "./Sustainability";
import PeopleAtCore from "./PeopleAtCore";

function HeroSection() {
  return (
    <div>
    <section className="hero">

      {/* Background Image */}
      <div className="hero-overlay"></div>

   
    

      {/* Hero Content */}
      <div className="hero-content">

        <p className="tagline">
          PREMIUM FURNITURE MANUFACTURERS & EXPORTERS
        </p>

        <h1>
          Crafting Timeless <br />
          Furniture For <br />
          Modern Living
        </h1>

        <p className="description">
          Blending craftsmanship, innovation, and premium materials
          to create elegant furniture collections for modern interiors
          worldwide.
        </p>


      

      </div>
     

    </section>
        <LuxuryFurnitureSection/>
        <FurnitureCategories/>
    <WhoWeAre/>
    <ProcessSection/>
    <MachineryTechnology/>
    <PeopleAtCore/>
    <Sustainability/>
    <BrandLogos/>
    
    </div>
  );
}

export default HeroSection;